import { api } from "../Api";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições do mapa
 */
export class MapRequests {

    /**
     * Faz a requisição dos dados para o mapa
     * @returns {Object} Lista de equipamentos
     */
    async MainRequest():Promise<any>{
        try {
            const response = await api.get('/pointsMap');
            return response.data;
        } catch (error: Error | any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async RequestCities():Promise<any>{
        try {
            const response = await api.get('/me/authorizedCities');
            return response.data;
        } catch (error: Error | any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async RequestData(id: string, groupFlag: boolean):Promise<any>{
        try {
            let response = {
                data: []
            }
            if(groupFlag){
                response = await api.get(`/mediaMappingMap/${id}?mode=groupping`);
            }else{
                response = await api.get(`/mediaMappingMap/${id}`);
            }
            return response.data;
        } catch (error: Error | any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async RequestTourFlag():Promise<any>{
        try {
            const response = await api.get('/me/setCheckedTutorial');
            return response.data;
        } catch (error: Error | any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async setNewDesignTag():Promise<any>{
        try {
            const response = await api.get('/me/setCheckedWarning');
            return response.data;
        } catch (error: Error | any ) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}